import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { LucideIcon } from "lucide-react";

interface StatCardWidgetProps {
  title: string;
  value: string | number;
  description: string;
  icon: LucideIcon;
  link: string;
}

export function StatCardWidget({ title, value, description, icon: Icon, link }: StatCardWidgetProps) {
  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        <Icon className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent className="flex-1 flex flex-col justify-between">
        <div>
          <div className="text-2xl font-bold">{value}</div>
          <p className="text-xs text-muted-foreground mt-1">{description}</p>
        </div>
        <Link to={link}>
          <Button variant="link" className="px-0 mt-2 h-auto">
            View details →
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
}
